var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    on: {
      "click": _vm.addClientNote
    }
  }, [_vm._v("+ pridať")]);

}
var staticRenderFns = []

export { render, staticRenderFns }